import { render, staticRenderFns } from "./grInfo.vue?vue&type=template&id=18280f8d&scoped=true&"
import script from "./grInfo.vue?vue&type=script&lang=js&"
export * from "./grInfo.vue?vue&type=script&lang=js&"
import style0 from "./grInfo.vue?vue&type=style&index=0&id=18280f8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18280f8d",
  null
  
)

export default component.exports